import { render, staticRenderFns } from "./Salesofkanban.vue?vue&type=template&id=49fce7d2&scoped=true"
import script from "./Salesofkanban.vue?vue&type=script&lang=js"
export * from "./Salesofkanban.vue?vue&type=script&lang=js"
import style0 from "./Salesofkanban.vue?vue&type=style&index=0&id=49fce7d2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49fce7d2",
  null
  
)

export default component.exports